import React from 'react';
/*
import {
  _ht,
  cr,
  BoxC,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as cr from './_cr';
import * as _ht from './_ht';

import * as icvI1zD10Co1 from './icvI1zD10Co1';
import * as icvI1zD10Co2 from './icvI1zD10Co2';
import * as icvI1zD10Co3 from './icvI1zD10Co3';
import * as icvI1zD10Co4 from './icvI1zD10Co4';

export const O = (pz: {
  sPz: _ht.dz,
  cz: {
    i10rs: _ht.ls, // 利用する部屋
    i17rs: _ht.ls,
    i1zz: _ht.dz,
    _601s: _ht.ls,
  }
}) => {


  return (

    cr.c(BoxC.N, {
      key: -10,
      abtType: 'baseAreaz',
      oClds: [

        pz.sPz.crt.steps[1] == 0 ? // 一覧: この画面では _31r_fst が確定していない
        cr.c(icvI1zD10Co1.N, {
          key: -10,
          sPz: pz.sPz,
          cz: {
            i10rs: pz.cz.i10rs,
            i17rs: pz.cz.i17rs,
            i1zz: pz.cz.i1zz,
            _601s: pz.cz._601s,
          }
        })
        : null,

        pz.sPz.crt.steps[1] == 1 ? // 登録
        cr.c(icvI1zD10Co2.N, {
          key: -20,
          sPz: pz.sPz,
          cz: {
            i10rs: pz.cz.i10rs,
            i17rs: pz.cz.i17rs,
            i1zz: pz.cz.i1zz,
            _601s: pz.cz._601s,
          }
        })
        : null,

        pz.sPz.crt.steps[1] == 2 ? // 確認
        cr.c(icvI1zD10Co3.N, {
          key: -30,
          sPz: pz.sPz,
          cz: {
            i10rs: pz.cz.i10rs,
            i17rs: pz.cz.i17rs,
            i1zz: pz.cz.i1zz,
            _601s: pz.cz._601s,
          }
        })
        : null,

        pz.sPz.crt.steps[1] == 3 ? // 完了
        cr.c(icvI1zD10Co4.N, {
          key: -40,
          sPz: pz.sPz,
          cz: {
            i10rs: pz.cz.i10rs,
            i17rs: pz.cz.i17rs,
            i1zz: pz.cz.i1zz,
            _601s: pz.cz._601s,
          }
        })
        : null,

      ]
    })
  );
};
